export default __webpack_public_path__ + "static/media/nodata.af1bbc8a.svg";